import Axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { segmentKeys } from "src/query-keys";

export function useSegmentDeleteMutation(scenarioId: number | string, segmentId: number | string) {
  const queryClient = useQueryClient();

  function mutationFn(scenarioId: number | string, segmentId: number | string) {
    const url = `/planning-api/scenarios/${scenarioId}/segments/${segmentId}`;
    return Axios.delete(url);
  }

  return useMutation(() => mutationFn(scenarioId, segmentId), {
    onSuccess: () => {
      queryClient.invalidateQueries(segmentKeys.all(scenarioId));
    },
  });
}
